import makeStyles from '@mui/styles/makeStyles';

const sidebarFavoritesTreeStyles = makeStyles((theme) => ({
    container: {
        padding: '8px 4px 0'
    },
    header: {
        padding: '4px 12px',
        borderRadius: 4,
        '&:hover': {
            backgroundColor: theme.palette.action.hover
        }
    },
    headerIcon: {
        minWidth: 24,
        color: theme.palette.text.secondary,
        '& .MuiSvgIcon-root': {
            fontSize: '16px'
        }
    },
    headerText: {
        fontSize: '11.5px',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        color: theme.palette.text.secondary
    },
    expandIcon: {
        fontSize: 18,
        color: theme.palette.text.secondary
    },
    item: {
        padding: '6px 12px 6px 36px',
        borderRadius: 6,
        borderLeft: '3px solid transparent',
        transition: 'background-color 0.15s, color 0.15s',
        '&:hover': {
            backgroundColor: 'rgba(255, 176, 30, 0.06)',
            color: theme.palette.text.primary
        }
    },
    itemText: {
        fontSize: '12.5px',
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    emptyText: {
        fontSize: '12px',
        color: theme.palette.text.secondary,
        padding: '8px 12px 4px 36px'
    },
    activeItem: {
        color: theme.palette.text.primary,
        backgroundColor: 'rgba(255, 176, 30, 0.07)',
        // @ts-ignore
        borderLeft: `3px solid ${theme.palette.accent.main}`,
        borderRadius: '0 6px 6px 0',
        '& $itemText': {
            color: theme.palette.text.primary,
            fontWeight: 600
        }
    }
}));

export default sidebarFavoritesTreeStyles;
